<template>
  <div class="search-filter">
    <h4>{{ title }}</h4>
    <hr />
    <!-- CATEGORY FILTER -->
    <div v-if="type === 'category'" class="options-wrapper">
      <div v-for="item in items" v-bind:key="item.name">
        <base-radio
          @input="handleFilterChange(type, item)"
          :name="item.name"
          v-model="radio.categoryFilter"
          type="info"
          >{{ item.value }}</base-radio
        >
      </div>
    </div>
    <!-- ORIENTATION FILTER -->
    <div v-if="type === 'orientation'" class="options-wrapper">
      <div v-for="item in items" v-bind:key="item.name">
        <base-radio
          @input="handleFilterChange(type, item)"
          :name="item.name"
          v-model="radio.orientationFilter"
          >{{ item.value }}</base-radio
        >
      </div>
    </div>
    <!-- COLOR FILTER -->
    <div v-if="type === 'color'" class="options-wrapper">
      <div v-for="item in items" v-bind:key="item.name">
        <base-radio
          @input="handleFilterChange(type, item)"
          :name="item.name"
          v-model="radio.colorFilter"
          >{{ item.value }}</base-radio
        >
      </div>
    </div>
    <!-- ARTIST FILTER -->
    <div v-if="type === 'artist'" class="options-wrapper">
      <base-input
        type="text"
        name="search"
        placeholder="Enter artist's username"
        @input="handleArtistFilter"
        v-model="artistFilterText"
        spellcheck="false"
        autocomplete="off"
        class="artist-filter"
      />
      <div class="artists-wrapper">
        <div v-for="item in artistsForFilter" v-bind:key="item.handle">
          <base-radio
            @input="handleFilterChange(type, item)"
            :name="item.handle"
            v-model="radio.artistFilter"
            >@{{ item.handle }}</base-radio
          >
        </div>
      </div>
      <div v-if="artistsForFilter.length > 16" class="artists-footer"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "search-filter",
  props: {
    title: {
      type: String,
      description: "Search filter title",
    },
    type: {
      type: String,
      description: 'Search filter type"',
    },
    items: {
      type: Array,
      description:
        'Filter options. Should be an array of objects {name: "", value: ""}',
      default: () => [],
    },
  },
  data() {
    return {
      radio: {
        categoryFilter: "all",
        orientationFilter: "all",
        colorFilter: "all",
        artistFilter: "all",
      },
      filteredArtists: [],
      artistFilterText: "",
    };
  },
  computed: {
    ...mapState(["allArtists"]),
    artistsForFilter() {
      if (this.artistFilterText) {
        return this.filteredArtists;
      } else {
        return this.allArtists;
      }
    },
  },
  methods: {
    handleFilterChange(type, item) {},
    handleArtistFilter() {
      this.filteredArtists = this.allArtists.filter(
        (artist) =>
          artist.handle
            .toLowerCase()
            .indexOf(this.artistFilterText.toLowerCase()) > -1
      );
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
.search-filter {
  margin-bottom: 2rem;

  h4 {
    color: #666;
    margin-bottom: 0.25rem;
    font-weight: 600;
  }

  hr {
    margin: 0;
  }

  .options-wrapper {
    margin-top: 1rem;
    padding-left: 0.5rem;
  }

  .artist-filter {
    margin-left: -0.5rem;
    margin-bottom: 1rem;

    .form-control {
      height: 36px;
    }
  }

  .artists-footer {
    height: 36px;
    margin-top: -36px;
    background: linear-gradient(to top, white, transparent);
    width: 100%;
    position: absolute;
  }

  .artists-wrapper {
    max-height: 400px;
    overflow-y: scroll;
    position: relative;
  }
}
</style>
